export enum OPTIMIZELY_FLAGS_ENUM {
  WISHLIST_ENTRY_POINTS = 'guest_engagement_wishlist_v2',
}
